var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-loading',{attrs:{"loading":_vm.gameMeta.loading}},[_c('game-form',{attrs:{"mode":"edit","game":_vm.game},on:{"submit":_vm.handleSubmit,"delete":_vm.handleDelete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }